import { render, staticRenderFns } from "./KickOutReportList.vue?vue&type=template&id=22f52110&"
import script from "./KickOutReportList.vue?vue&type=script&lang=js&"
export * from "./KickOutReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports